import React, { useEffect, useState } from "react";
import API from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";

const Card = () => {
  const [cards, setCards] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 10;
  const [search, setSearch] = useState("")

  useEffect(() => {
    getCardsData(currentPage)
  }, [currentPage])


  // const handleFieldChange = (e, fieldName) => {
  //   const value = e.target.value;
  //   switch (fieldName) {
  //     case "search":
  //       setSearch(value);
  //       break;
  //     default:
  //       break;
  //   }
  // }
  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (fieldName === "search") {
      setSearch(value);
      if (value.trim() === "") {
        setCurrentPage(1);
        getCardsData(1);
      }
    }
  };



  const getCardsData = async (currentPage) => {
    try {
      const payload = {
        limit: perPage,
        pageNumber: currentPage,
        search: search,
      };
      const response = await API.getCards(payload);
      // console.log("data..", response)
      setCards(response?.data?.data || []);
      const totalPages = Math.ceil(response?.data?.total_count / perPage);
      setTotalCount(response?.data?.total_count);
      setTotalPages(totalPages);
    } catch (error) {
      handleError(error);
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
        // toast.error("Network error! Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };


  const handleError = (error) => {
    console.error("Error:", error);
    if (error.response) {
      toast.error(error.response.data?.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      toast.error("No response from server. Please try again later.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);
      if (left > 2) {
        pageNumbers.push(1, '...');
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push('...', totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };
  const handleSearch = () => {
    if (search.trim() === "") {
      setCurrentPage(1);
      getCardsData(1); 
    } else {
      setCurrentPage(1);
      getCardsData(1);
    }
  };

  const downloadCSV = async () => {
    try {
      const payload = {
        limit: 0,
        pageNumber: currentPage,
        search: search,
      };

      const data = await API.getCards(payload);
      const result = data?.data?.data || [];
      if (!result.length) {
        toast.error("No data found!");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(result);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CardReport");
      XLSX.writeFile(workbook, "CardReport.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">
              Total Cards ({totalCount})
            </h4>

            {totalCount > 0 && (
              <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                <i className="fa fa-download"></i>
              </button>
            )}
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <input type="text" className="form-control" placeholder="Search By Name Or Mobile Or Card Number"
                  value={search}
                  onChange={(e) => handleFieldChange(e, "search")}
                />
              </div>
              <div className="col-md-2">
                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Customer Name</th>
                    <th>Mobile</th>
                    <th>Card Number</th>
                    <th>SkyCoins</th>
                    <th>Loyalty Points</th>
                    <th>Tickets</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {cards.map((item, index) => (
                    // console.log("item data...", item),
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>{item.customer_name}</td>
                      <td>{item.mobile}</td>
                      <td>{item.card_number || "Non Assigned Card"}</td>
                      <td>{item.play_points}</td>
                      <td>{item.loyalty_points}</td>
                      <td>{item.tickets}</td>
                      <td>{item.is_active ? "Activated" : "De-Activated"}</td>
                      <td>{item.createdAt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}>
                      Previous
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    // console.log("page,index", page,index),
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      )}
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>

  );
};

export default Card;